export const EMAIL_OR_PASSWORD_ERROR = 'Email or password is incorrect.';
export const INCORRECT_VERIFICATION_CODE_ERROR = 'Incorrect Verification Code';
export const GENERAL_ERROR_CONTACT_SUPPORT = 'Something wrong happened. Contact support';
export const GENERAL_ERROR_TRY_LATER = 'Some error occurred. Please try again later.';
